import React from 'react';

const EditModuleManagementJobFamilyPage = () => {
  return <div>EditModuleManagementJobFamilyPage</div>;
};

export default EditModuleManagementJobFamilyPage;
